module.exports = __webpack_public_path__ + "img/address-card.3c6b4f89.svg";